import { CAFE_PORTFOLIO_IMAGES, DEFAULT_CAFE_IMAGE } from "./cafePortfolioImages";
import { CORPORATE_PORTFOLIO_IMAGES, DEFAULT_CORPORATE_IMAGE } from "./corporatePortfolioImages";
import { HOSPITAL_PORTFOLIO_IMAGES, DEFAULT_HOSPITAL_IMAGE } from "./hospitalPortfolioImages";
import { DEFAULT_EDUCATION_IMAGE, EDUCATION_PORTFOLIO_IMAGES } from "./educationPortfolioImages";
import { COMMERCE_PORTFOLIO_IMAGES, DEFAULT_COMMERCE_IMAGE } from "./commercePortfolioImages";
import { DEFAULT_RESTAURANT_IMAGE, RESTAURANT_PORTFOLIO_IMAGES } from "./restaurantPortfolioImages";
import { DEFAULT_REAL_ESTATE_IMAGE, REAL_ESTATE_PORTFOLIO_IMAGES } from "./realEstatePortfolioImages";
import { BEAUTY_HEALTH_PORTFOLIO_IMAGES, DEFAULT_BEAUTY_HEALTH_IMAGE } from "./beautyHealthPortfolioImages";

/** @typedef {{ id: string, title: string, url: string, src?: string }} PortfolioGalleryItem */

/**
 * @typedef {{
 *   images: PortfolioGalleryItem[],
 *   default: PortfolioGalleryItem,
 *   accent: string,
 *   testId: string,
 *   ariaLabel: string,
 *   panelPrefix: string,
 *   placeholderLead?: string,
 * }} PortfolioGalleryConfig
 */

/** @type {Record<string, PortfolioGalleryConfig>} */
export const PORTFOLIO_GALLERY_REGISTRY = {
  corporate: {
    images: CORPORATE_PORTFOLIO_IMAGES,
    default: DEFAULT_CORPORATE_IMAGE,
    accent: "#1a365d",
    testId: "corporate-portfolio-gallery",
    ariaLabel: "기업 포트폴리오",
    panelPrefix: "corporate-panel",
  },
  restaurant: {
    images: RESTAURANT_PORTFOLIO_IMAGES,
    default: DEFAULT_RESTAURANT_IMAGE,
    accent: "#ff6a1a",
    testId: "restaurant-portfolio-gallery",
    ariaLabel: "음식점 포트폴리오",
    panelPrefix: "restaurant-panel",
  },
  cafe: {
    images: CAFE_PORTFOLIO_IMAGES,
    default: DEFAULT_CAFE_IMAGE,
    accent: "#00704a",
    testId: "cafe-portfolio-gallery",
    ariaLabel: "카페 포트폴리오",
    panelPrefix: "cafe-panel",
  },
  hospital: {
    images: HOSPITAL_PORTFOLIO_IMAGES,
    default: DEFAULT_HOSPITAL_IMAGE,
    accent: "#0e7490",
    testId: "hospital-portfolio-gallery",
    ariaLabel: "병원 포트폴리오",
    panelPrefix: "hospital-panel",
  },
  education: {
    images: EDUCATION_PORTFOLIO_IMAGES,
    default: DEFAULT_EDUCATION_IMAGE,
    accent: "#4f46e5",
    testId: "education-portfolio-gallery",
    ariaLabel: "교육·학원 포트폴리오",
    panelPrefix: "education-panel",
  },
  commerce: {
    images: COMMERCE_PORTFOLIO_IMAGES,
    default: DEFAULT_COMMERCE_IMAGE,
    accent: "#db2777",
    testId: "commerce-portfolio-gallery",
    ariaLabel: "쇼핑몰 포트폴리오",
    panelPrefix: "commerce-panel",
  },
  "real-estate": {
    images: REAL_ESTATE_PORTFOLIO_IMAGES,
    default: DEFAULT_REAL_ESTATE_IMAGE,
    accent: "#0d9488",
    testId: "real-estate-portfolio-gallery",
    ariaLabel: "부동산 포트폴리오",
    panelPrefix: "real-estate-panel",
  },
  "beauty-health": {
    images: BEAUTY_HEALTH_PORTFOLIO_IMAGES,
    default: DEFAULT_BEAUTY_HEALTH_IMAGE,
    accent: "#be185d",
    testId: "beauty-health-portfolio-gallery",
    ariaLabel: "미용·헬스 포트폴리오",
    panelPrefix: "beauty-health-panel",
  },
  startup: {
    images: [],
    default: { id: "startup", title: "스타트업·SaaS", url: "startup-saas.dsite" },
    accent: "#6366f1",
    testId: "startup-portfolio-gallery",
    ariaLabel: "스타트업·SaaS 포트폴리오",
    panelPrefix: "startup-panel",
    placeholderLead: "스타트업·SaaS·서비스 소개 랜딩 페이지 제작 사례",
  },
};

export const GALLERY_VARIANT_IDS = Object.keys(PORTFOLIO_GALLERY_REGISTRY);

export function isGalleryVariant(variant) {
  return variant in PORTFOLIO_GALLERY_REGISTRY;
}

export function getGalleryConfig(variant) {
  return PORTFOLIO_GALLERY_REGISTRY[variant] ?? null;
}

export function getGalleryDefault(variant) {
  return PORTFOLIO_GALLERY_REGISTRY[variant]?.default ?? null;
}
